/// <reference path="../../../app.definition.ts" />
import angular from 'angular';
import { Util } from '@common/util';

type TServiceTemplateOption = {
  optionId: number;
  label: string;
  locked: string;
  required: string;
  value: string;
  unit?: string;
};

type TNewService = {
  code: string;
  serviceTypeId: number;
  providerTypeId: number;
  description: string;
  serviceTemplateOptions: TServiceTemplateOption[];
};
export class EnterpriseServicesPopupController {

  static $inject = ["$q", "$timeout", "$uibModalInstance", "NgTableParams", "$injector", "CacheService", "PopUpService", "ApiAdapterService", "ServiceManager"];
  constructor($q, $timeout,
    $uibModalInstance, NgTableParams, $injector, $_cache: eCareVault.CacheService, PopUpService, ApiAdapterService,
    private $_serviceManager: eCareVault.IServiceManager) {
    var enterpriseServicesPopupVm: any = this;
    enterpriseServicesPopupVm.util = Util;
    enterpriseServicesPopupVm.$validationProvider = $injector.get('$validation');
    enterpriseServicesPopupVm.iconColor = Util.COLORS.primaryText;
    enterpriseServicesPopupVm.enterpriseService = {};


    enterpriseServicesPopupVm.loadData = true;

    enterpriseServicesPopupVm.groupSizeList = Util.getGroupList();

    enterpriseServicesPopupVm.getTableConfiguration = (data: any, sortingParam: any, count: number) => {
      var tableParams = {
        sorting: sortingParam,
        count: count
      };

      var tableSettings = {
        counts: [],
        paginationMaxBlocks: 3,
        paginationMinBlocks: 2,
        dataset: data
      };

      return new NgTableParams(tableParams, tableSettings);
    }

    enterpriseServicesPopupVm.keyUpTextArea = () => {
      if (enterpriseServicesPopupVm.enterpriseService.description == "") {
        enterpriseServicesPopupVm.descLabel = false;
      } else {
        enterpriseServicesPopupVm.descLabel = true;
      }
    }

    if (enterpriseServicesPopupVm.loadData) {
      ApiAdapterService.getEnterpriseServiceOptions().then(
        (s) => {
          enterpriseServicesPopupVm.serviceOptions = s;

          enterpriseServicesPopupVm.serviceOptions.forEach(function (element) {
            if (element.type == "text") {
              enterpriseServicesPopupVm.formatValueList = JSON.parse(element.displayValue);
              console.log(typeof enterpriseServicesPopupVm.formatValueList);
            } else if (element.type == "time") {
              enterpriseServicesPopupVm.unitTypeLabel = element.unitTypeLabel;
                $_serviceManager.getServiceTimeUnits().then((s) => {
                enterpriseServicesPopupVm.timeUnits = s[enterpriseServicesPopupVm.unitTypeLabel];
              })
            }
          });

          var assignedSorting = {
            label: 'asc'
          }
          enterpriseServicesPopupVm.serviceOptionsTableParams = enterpriseServicesPopupVm.getTableConfiguration(s, assignedSorting, 3);
        },
        e => {
          console.log('error while fetching service unit types');
          console.log(e);
        }
      );
      ApiAdapterService.getEnterpriseServicesTypes().then(
        (s) => {
          enterpriseServicesPopupVm.serviceTypes = s;
        },
        e => {
          console.log('error while fetching service types');
          console.log(e);
        }
      );
      ApiAdapterService.getEnterpriseProviderTypes().then(
        (s) => {
          enterpriseServicesPopupVm.providerTypes = s;
        },
        e => {
          console.log('error while fetching service types');
          console.log(e);
        }
      );
    }

    enterpriseServicesPopupVm.formatChange = () => {
      let grpSzOpt = enterpriseServicesPopupVm.serviceOptions.findIndex(o => o.type == 'groupSize');
      if (enterpriseServicesPopupVm.enterpriseService.defaultTextVal.key == "Group") {
        if (grpSzOpt == -1)
          enterpriseServicesPopupVm.serviceOptions.push({ "label": "Group Size", "type": "groupSize" });
      } else {
        if (grpSzOpt > -1) {
          enterpriseServicesPopupVm.serviceOptions.splice(grpSzOpt, 1);
          enterpriseServicesPopupVm.enterpriseService.groupSize = "";
        }
      }
      var assignedSorting = {
        label: 'asc'
      }
      enterpriseServicesPopupVm.serviceOptionsTableParams = enterpriseServicesPopupVm.getTableConfiguration(enterpriseServicesPopupVm.serviceOptions, assignedSorting, 3);
    }

    enterpriseServicesPopupVm.dismiss = () => {
      $uibModalInstance.close();
    }

    enterpriseServicesPopupVm.prepareCreateServiceModel = (serviceRecord: Object) => {
      const newService: TNewService = {
        code: enterpriseServicesPopupVm.enterpriseService.code,
        serviceTypeId: enterpriseServicesPopupVm.enterpriseService.serviceType.id,
        providerTypeId: enterpriseServicesPopupVm.enterpriseService.providerType.id,
        description: enterpriseServicesPopupVm.enterpriseService.description,
        serviceTemplateOptions: []
      };

      // var cycleObj={};
      // cycleObj.optionId=enterpriseServicesPopupVm.enterpriseService.timeOptionId;
      // cycleObj.label="time"
      // cycleObj.locked="true";
      // cycleObj.required="false";
      // cycleObj.unit=enterpriseServicesPopupVm.enterpriseService.timeUnit.unitType;
      // cycleObj.value=enterpriseServicesPopupVm.enterpriseService.timeValue;

      const formatObj: TServiceTemplateOption = {
        optionId: enterpriseServicesPopupVm.enterpriseService.textOptionId,
        label: "text",
        locked: "true",
        required: "false",
        value: enterpriseServicesPopupVm.enterpriseService.defaultTextVal.key
      };

      //newService.serviceTemplateOptions.push(cycleObj);
      newService.serviceTemplateOptions.push(formatObj);

      if (enterpriseServicesPopupVm.enterpriseService.defaultTextVal.key == "Group") {
        var groupObj: TServiceTemplateOption = {
          optionId: 123,
          label: "Group",
          locked: "true",
          required: "false",
          value: enterpriseServicesPopupVm.enterpriseService.groupSize
        };
        newService.serviceTemplateOptions.push(groupObj);
      }


      return newService;
    }

    enterpriseServicesPopupVm.save = (serviceRecord: any) => {
      var deferred = $q.defer();
      enterpriseServicesPopupVm.$validationProvider.validate(serviceRecord)
        .success(() => {
          var newServiceSaveModel = enterpriseServicesPopupVm.prepareCreateServiceModel(serviceRecord);
          ApiAdapterService.createNewService(newServiceSaveModel).then(
            (s) => {
              $uibModalInstance.close(TextTrackCueList);
              let success_msg = Util.SERVICE_CREATED_SUCCESSFULLY;
              toastr.success(success_msg, "");
              deferred.resolve();
            },
            e => {
              PopUpService.openInformationModal(e, null, null, null, true).then((s) => { });
              console.log('error while saving service');
              console.log(e);
              deferred.reject();
            }
          );
        }).error(function (message) {
          console.log("Validation Error:", message)
          $timeout(() => {
            deferred.reject();
          }, 1000);
        });
      return deferred.promise;
    }

    enterpriseServicesPopupVm.cancel = () => {
      $uibModalInstance.dismiss();
    }
  }
}

angular.module('eCareVault.common.popUp')
  .controller('EnterpriseServicesPopupController', EnterpriseServicesPopupController);
